<div >

	<div >


		<!-- <div class="custom-card card clickable-card"> -->
			<!-- <div class="flex-container card">
				<div class="header"><img class="appTile" src="https://i.imgur.com/gtHbMD1.png" /></div>
				<div class="header-padding"></div>
				<div class="applicationlink-icon"><img style="width: 70px; height: 70px;" src="https://i.imgur.com/rkwEj1G.png"></div>
				<div class="integrationtitle-flexbox"><div class="integrationtitle">Exact Online</div><div class="integrationsubtitle">Invoice Integration</div></div>
				<div class="applicationlink-add-link-button"><div><button class="custom-button">Add link</button></div></div>
			 </div>

			 <div class="flex-container card">
				<div class="header"><img class="appTile" src="https://i.imgur.com/gtHbMD1.png" /></div>
				<div class="header-padding-apptiles"></div>
				<div class="applicationlink-icon"><img style="width: 70px; height: 70px;" src="https://i.imgur.com/rkwEj1G.png"></div>
				<div class="integrationtitle-flexbox"><div class="integrationtitle">Exact Online</div><div class="integrationsubtitle">Invoice Integration</div></div>
				<div class="applicationlink-divider"><hr></div>
				<div class="applicationlink-buttons">
					<div class="button-container">
						<div class="document-icon far fa-file-alt fa-3x fa-fw"></div>
						<div class="chart-icon far fa-chart-line fa-3x fa-fw"></div>
						<div class="agenda-icon clickable-icon far fa-calendar-alt fa-3x scheduler fa-fw"></div>
						<span class="arrow">
							<div class="playbutton-icon far fa-play fa-3x arrowicon clickable fa-fw"></div>
						</span>
					</div>
				</div>
			 </div> -->
		<!-- </div> -->


		<ng-container *ngIf="applications$ | async as applications">
			<dx-data-grid [showBorders]="true" [dataSource]="applications" [columns]="['displayName', 'imageRef']">

				<dxo-paging [pageSize]="10"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50]" [showInfo]="true">
				</dxo-pager>

				<dxi-column dataField="imageRef" caption="Image" [allowFiltering]="false" [allowSorting]="false"
					cellTemplate="imageTemplate" [width]="75"></dxi-column>
				<dxi-column dataField="displayName" caption="Display Name"> </dxi-column>
				<dxi-column dataField="name" caption="Name"> </dxi-column>

				<dxi-column type="buttons">
					<dxi-button icon="far fa-pencil btn-edit" hint="Edit" [onClick]="onEditApplication">
					</dxi-button>
				</dxi-column>

				<div *dxTemplate="let data of 'imageTemplate'">
					<img class="appImage" [src]="getUrl('/application-logos/'+data.value)" />
				</div>
			</dx-data-grid>
		</ng-container>
	</div>
</div>
